import { useTranslation } from 'react-i18next'

import { EyeIcon } from '@phosphor-icons/react'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'
import { statuses } from '@/returns/constants'

const TransactionsOnHold = ({ transactionsOnHold, onClick }) => {
  const { t } = useTranslation()
  const count = Number(transactionsOnHold)
  const hasValue = count > 0

  return (
    <Statistic
      size="small"
      status={hasValue ? statisticStatuses.warning : statisticStatuses.default}
      Icon={EyeIcon}
      label={t('Transacciones en espera')}
      showStatusIcon={hasValue}
      value={<AnimatedNumber target={count} format="decimal" />}
      onClick={() => onClick(statuses.onHold)}
    />
  )
}

export default TransactionsOnHold
